import {
    FETCH_MODULE,
    FETCH_MODULE_UPDATE,
    FETCH_MODULE_SUCCESS,
    FETCH_MODULE_FAILED,
  } from "../store/types";

const INITIAL_STATE = {
    info: null,
    loading: false,
    error: {
      flag: false,
      msg: null
    }
}

export const modulesreducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case FETCH_MODULE:
            return {
                ...state,
                loading: true
            };
        case FETCH_MODULE_SUCCESS:
            return {
                ...state,
                info: action.payload,
                loading: false,
                error: {
                    flag: false,
                    msg: null
                },
            };
        case FETCH_MODULE_FAILED:
            return {
                ...state,
                loading: false,
                error: {
                    flag: true,
                    msg: action.payload
                },
                info: null
            };
        case FETCH_MODULE_UPDATE:
            return {
                ...state,
                info: action.payload,
                loading: false,
                error: {
                    flag: false,
                    msg: null
                },
            };
        default:
            return state;
    }
}